<template>
  <v-app class="app">
    <v-system-bar color="white" absolute style="z-index: 3000" window lights-out v-if="!$store.state.user.Usu_TieneClientes && $route.name != 'Authenticate'">
        <v-row class="justify-center black--text">
          <v-icon size="20" color="red">mdi-alert</v-icon>
          Este usuario no tiene clientes asignados, por favor asigne clientes desde el 
          <a :href="urlAdminYomob" class="purple--text mx-1 font-weight-bold">Admin de yomob</a> 
          para el correcto funcionamiento de este sistema!
        </v-row>
    </v-system-bar>

    <v-overlay :value="loadPage.show" class="text-center" :opacity="0.7" z-index="1000">
      <v-row class="justify-center">
        <Loader v-if="true"></Loader>
        <v-progress-circular
          indeterminate
          color="purple"
          size="64"
          v-else
        ></v-progress-circular>
      </v-row>
      <p class="mt-4 font-weight-bold" style="font-size: 1.2rem;">{{loadPage.message}}</p>
    </v-overlay>


    <v-app-bar class="bar" 
              app 
              height="60" 
              :color="($store.state.lookSoofia) ? 'white' : 'purple'" 
              :dark="($store.state.lookSoofia) ? false : true"
              :elevation="($store.state.lookSoofia) ? 0 : 24"
              v-if="$store.state.user.Usu_Id"
    >
      <v-btn icon @click="drawer = !drawer" :disabled="($route.name == 'Unauthorized' || $route.name == 'Authenticate')">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <Header :drawer="drawer"></Header>
    </v-app-bar>
    
    
    <Navigation v-if="$store.state.user.Usu_Id" :drawer="drawer" @updateDrawer="drawer = $event"></Navigation>

    <v-main :class="`main-custom ${$store.state.lookSoofia ? 'soofia-main' : ''}`">
      <v-container class="pa-1">
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-snackbar
      vertical
      v-model="$store.state.quickMessage.snackbar.show"
      :color="$store.state.quickMessage.snackbar.color"
      :timeout="$store.state.quickMessage.snackbar.time"
      top
      elevation="24"
      >
        <div v-if="$store.state.quickMessage.snackbar.isArray">
          <div>
            <strong>{{ $store.state.quickMessage.snackbar.title }}</strong>
          </div><br>
          <div v-for="(item, index) in $store.state.quickMessage.snackbar.message" :key="index">
            - {{ item.text }}
          </div>
        </div>
        <div v-else >{{ $store.state.quickMessage.snackbar.message }}</div>
        <template v-slot:action="{ attrs }">
          <v-btn color="white"
                  text
                  v-if="$store.state.quickMessage.snackbar.buttonClose === true"
                  v-bind="attrs"
                  @click="$store.state.quickMessage.snackbar.show = false">
                        Cerrar
            </v-btn>
        </template>
    </v-snackbar>
  </v-app>
</template>

<script>

import Header from "./views/app/Header.vue";
import Navigation from "./views/app/Navigation.vue";
import Loader from "./views/app/loader.vue";
import eventBus from "./event-bus.js"
export default {
  name: 'App',

  components: {
    Header,
    Navigation,
    Loader
  },
  data: () => ({
    drawer: true,
    loadPage : { show: false, message: 'Cargando...' },
  }),
  created(){
    const data = {
                    show: false,
                    message:"",
                    color: "",
                }

    this.$store.dispatch("quickMessage/activeMessage", data);
  },
  mounted(){
    let vm = this;
    eventBus.$on("loadPage", function (data) {
      vm.loadPage = data;
    });
  },
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    currentRouteName() {
      return this.$route.name;
    },
    urlAdminYomob(){
      let url = (window.location.href.includes('localhost')) ? 'http://localhost:4200' : 
                  (window.location.href.includes('dev-')) ? 'https://dev-yomob-admin.uxshows.com' : 'https://yomob-admin.uxshows.com'
      return url + '/usuarios/form/' + this.$store.state.user.Usu_Id
    }
  },
  watch:{
    '$route.name'(val){
      if(val == 'Unauthorized' || val == 'Authenticate') this.drawer = false
      else this.drawer = true
    },
    '$store.state.lookSoofia': {
      handler(val){
        if(val){
          this.$store.dispatch('changeVuetifyTheme')
          this.changeFavicon('/favicon-soofia.ico')
        }
      }, deep: true, immediate: true
    }
  },
  methods:{
    changeFavicon(iconPath) {
      let link = document.querySelector("link[rel*='icon']");
      if (!link) {
        link = document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        document.head.appendChild(link);
      }
      link.href = iconPath;
    }
  }
};
</script>

<style>
  .main-custom {
    background: #F7F7F7;
  }

  /* width */
  ::-webkit-scrollbar {
    width: .9rem !important;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f2f3f8 !important;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #B2B2B2 !important;
    border-radius: 10px !important;
  }
</style>
